import React, { Component } from "react";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import ThisTable from "../../Common/ThisTable";
import { languageService } from "../../../Language/language.service";
import CommonModalStateless from "../../Common/CommonModalStateless";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { ToastService } from "../../../utils/toastify";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "../../../reduxCURD/actions";
import { commonPageStyle } from "../../Common/Summary/styles/CommonPageStyle";
import { commonFilterStyles } from "../../Common/Filters/styles/CommonFilterStyle";
import { themeService } from "../../../theme/service/activeTheme.service";
import { ButtonActionsTable } from "components/Common/Buttons";
class WareHouse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 10,
      page: 0,
      dropdownOpen: false,
      showSyncModal: false,
      columns: [
        {
          Header: languageService("Warehouse Code"),
          accessor: "opt1.warehouseCode",
          Cell: (row) => (
            <span>
              {row.original.opt1.warehouseCode}{" "}
              {row.original.opt1 && row.original.opt1.isDefault && (
                <span style={{ fontWeight: "700", color: "#000000", marginRight: "5px" }}>({languageService("Default")})</span>
              )}
            </span>
          ),
        },
        {
          Header: languageService("Name"),
          accessor: "opt1.name",
        },
        {
          Header: languageService("Actions"),
          accessor: "actions",
          style: { textAlign: "center" },
          Cell: (row) => (
            <div>
              {(row.original.opt1.isDefault === false || row.original.opt1.isDefault === undefined) && (
                <ButtonActionsTable
                  handleClick={() => this.handleDefaultServer(row.original)}
                  margin="0px 10px 0px 0px"
                  buttonText={languageService("Set Default")}
                />
              )}
            </div>
          ),
        },
      ],
    };

    this.toggle = this.toggle.bind(this);
    this.handlePageSave = this.handlePageSave.bind(this);
    this.openSyncModal = this.openSyncModal.bind(this);
    this.closeSyncModal = this.closeSyncModal.bind(this);
    this.postSyncedWarehouses = this.postSyncedWarehouses.bind(this);
    this.handleDefaultServer = this.handleDefaultServer.bind(this);
  }

  handleDefaultServer(warehouse) {
    console.log("Default Server clicked for:", warehouse);
    this.props.updateWarehouseSync({ code: warehouse.code }, "setDefault");
  }

  componentDidMount() {
    this.props.getApplicationlookupss("wims-wareHouse");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionType !== this.props.actionType || prevProps.WarehouseSyncActionType !== this.props.WarehouseSyncActionType) {
      const actionType = this.props.actionType || this.props.WarehouseSyncActionType;

      if (actionType === "WAREHOUSESYNCS_READ_SUCCESS") {
        this.setState({ showSyncModal: true });
      }

      if (actionType === "WAREHOUSESYNC_CREATE_SUCCESS") {
        ToastService.Success(languageService("Warehouses Synced successfully."));
        this.closeSyncModal();
        this.props.getApplicationlookupss("wims-wareHouse");
      }

      if (actionType === "WAREHOUSESYNC_UPDATE_SUCCESS") {
        ToastService.Success(languageService("Default warehouse set successfully."));
        this.props.getApplicationlookupss("wims-wareHouse");
      }

      if (actionType === "WAREHOUSESYNCS_UPDATE_FAILURE") {
        ToastService.Error(languageService("Failed to set default warehouse."));
      }
    }
  }

  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  handlePageSave(page, pageSize) {
    this.setState({
      page: page,
      pageSize: pageSize,
    });
  }

  openSyncModal() {
    this.props.getWarehouseSyncs("");
  }

  closeSyncModal() {
    this.setState({ showSyncModal: false });
  }

  postSyncedWarehouses() {
    const rawLookups = this.props.applicationlookupss || [];
    const applicationLookupsArray = Array.isArray(rawLookups) ? rawLookups : rawLookups.data || [];
    const existingCodes = applicationLookupsArray.filter((item) => item.listName === "wims-wareHouse").map((w) => w.code);
    const warehouseSyncData = (this.props.WarehouseSyncs && this.props.WarehouseSyncs.data) || [];
    const filteredWarehouseSyncData = warehouseSyncData.filter((item) => !existingCodes.includes(item.code));

    if (filteredWarehouseSyncData.length > 0) {
      this.props.createWarehouseSync(filteredWarehouseSyncData, "data");
    } else {
      ToastService.Error(languageService("No new warehouses to sync."));
    }
  }

  render() {
    const { columns, pageSize, page, dropdownOpen, showSyncModal } = this.state;

    const rawLookups = this.props.applicationlookupss || [];
    const applicationLookupsArray = Array.isArray(rawLookups) ? rawLookups : rawLookups.data || [];
    const warehouseList = applicationLookupsArray.filter((item) => item.listName === "wims-wareHouse");

    const warehouseSyncData = (this.props.WarehouseSyncs && this.props.WarehouseSyncs.data) || [];

    // Filter out warehouses that already exist in the local DB (duplicate prevention)
    const existingCodes = warehouseList.map((w) => w.code);
    const filteredWarehouseSyncData = warehouseSyncData.filter((item) => !existingCodes.includes(item.code));

    const pageOptions = [5, 10, 15, 20, 25, 30, 40, 50].map((option) => {
      return (
        <DropdownItem
          onClick={() => {
            this.handlePageSave(0, option);
          }}
          key={option}
          style={themeService(commonFilterStyles.pageSizeStyle)}
        >
          {option}
        </DropdownItem>
      );
    });

    return (
      <div className="ims-sub-content">
        <Col className="mainContent" md="12">
          <Row>
            <Col md="9">
              <div style={{ ...themeService(commonPageStyle.commonSummaryHeadingContainer), display: "inline-block" }}>
                <h4 style={themeService(commonPageStyle.commonSummaryHeadingStyle)}>{languageService("Warehouse List")}</h4>
              </div>
            </Col>
            <Col md="3" style={{ textAlign: "right", paddingTop: "10px", paddingRight: "30px" }}>
              {warehouseList.length === 0 ? (
                <MyButton onClick={this.openSyncModal}>{languageService("Sync Warehouses")}</MyButton>
              ) : (
                <MyButton onClick={this.openSyncModal}>{languageService("Refetch")}</MyButton>
              )}
            </Col>
            <hr style={{ borderBottom: "1px solid rgb(209, 209, 209)", width: "96.5%" }}></hr>
          </Row>

          <Row>
            <Col md={1}>
              <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }} key="pageSize">
                <Dropdown isOpen={dropdownOpen} toggle={this.toggle} size="sm">
                  <DropdownToggle style={themeService(commonFilterStyles.pageSizeTogglerStyle)} caret>
                    {pageSize}
                  </DropdownToggle>
                  <DropdownMenu style={{ minWidth: "auto", fontSize: "12px", padding: "0px" }}>{pageOptions}</DropdownMenu>
                </Dropdown>
              </div>
            </Col>
            <Col md="12">
              <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }}>
                <ThisTable
                  tableColumns={columns}
                  tableData={warehouseList}
                  pageSize={pageSize}
                  minRows={1}
                  pagination={true}
                  forDashboard={false}
                  handlePageChange={(page) => this.handlePageSave(page, pageSize)}
                  page={page}
                  height={"auto"}
                  onClickSelect
                />
              </div>
            </Col>
          </Row>
        </Col>

        {showSyncModal && (
          <CommonModalStateless
            isOpen={showSyncModal}
            headerText={warehouseList.length === 0 ? languageService("Warehouses list") : languageService("Warehouse list")}
            modalStyle={{ maxWidth: "60vw" }}
            footerContent={
              <div>
                <MyButton onClick={this.closeSyncModal} customStyle={{ margin: "0 10px 0 0" }}>
                  {languageService("Cancel")}
                </MyButton>
                <MyButton onClick={this.postSyncedWarehouses} disabled={filteredWarehouseSyncData.length === 0}>
                  {warehouseList.length === 0 ? languageService("Add") : languageService("Update")}
                </MyButton>
              </div>
            }
          >
            <div style={{ padding: "15px" }}>
              <ThisTable
                tableColumns={columns.filter((e) => e.accessor !== "actions")}
                tableData={filteredWarehouseSyncData}
                pageSize={10}
                minRows={1}
                pagination={true}
                forDashboard={false}
                height={"auto"}
              />
            </div>
          </CommonModalStateless>
        )}
      </div>
    );
  }
}

const getApplicationlookupss = curdActions.getApplicationlookupss;

const actionOptions = {
  create: true,
  update: true,
  read: true,
  delete: false,
  others: {
    getApplicationlookupss,
  },
};

const variables = {
  WarehouseSyncReducer: { WarehouseSync: {}, WarehouseSyncs: [] },
  applicationlookupsReducer: { applicationlookupss: [] },
};

export default CRUDFunction(
  WareHouse,
  "WarehouseSync",
  actionOptions,
  variables,
  ["WarehouseSyncReducer", "applicationlookupsReducer"],
  "wims/warehouses",
);



// WEBPACK FOOTER //
// ./src/components/IMS/WareHouse/WareHouse.jsx